export default {
  projectDesc: 'A <strong>Vue2</strong> plugin for images show in gallery or carousel',
  demo: {
    carousel: 'Carousel show images mode',
    galleryLight: 'Galley mode light theme',
    galleryDark: 'Gallery mode dark theme',
    galleryCustom: 'Gallery mode custom display'
  },
  option: {
    type: 'display mode',
    images: 'images source, data format like this',
    pause: 'show pause button in gallery or carousel mode controls',
    title: 'show image title in galley or carousel mode controls',
    dark: 'gallery mode dark theme',
    caption: 'gallery mode image show caption block'
  }
}
